var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33398 5.99219V3.32552H7.66732V5.99219H10.334V7.32552H7.66732V9.99219H6.33398V7.32552H3.66732V5.99219H6.33398ZM7.00065 13.3255C3.31875 13.3255 0.333984 10.3407 0.333984 6.65885C0.333984 2.97695 3.31875 -0.0078125 7.00065 -0.0078125C10.6825 -0.0078125 13.6673 2.97695 13.6673 6.65885C13.6673 10.3407 10.6825 13.3255 7.00065 13.3255ZM7.00065 11.9922C9.94618 11.9922 12.334 9.60439 12.334 6.65885C12.334 3.71333 9.94618 1.32552 7.00065 1.32552C4.05513 1.32552 1.66732 3.71333 1.66732 6.65885C1.66732 9.60439 4.05513 11.9922 7.00065 11.9922Z",
    fill: "#026094"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBlue);
export default __webpack_public_path__ + "static/media/addBlue.e2a3874994876210a06b50b64e856159.svg";
export { ForwardRef as ReactComponent };